const wilsonHostedStorageKey = 'store.wilsonHostedFilter';
const partnerHostedStorageKey = 'store.partnerHostedFilter';
const inPersonStorageKey = 'store.inPersonFilter';
const virtualStorageKey = 'store.virtualFilter';
const graduateCreditStorageKey = 'store.graduateCreditFilter';
const FundationsStorageKey = 'store.FundationsFilter';
const WrsStorageKey = 'store.WrsFilter';
const JustWordsStorageKey = 'store.JustWordsFilter';
const EsperanzaSmlStorageKey = 'store.EsperanzaSmlFilter';
const OtherStorageKey = 'store.OtherFilter';
let isFirstLoad = true;


$("fieldSet").find("input").on("change", applyFilterGroups);

$("#ShowAll").on("click", showAll);


// Reveal grid once it finishes initializing so that the filter has been applied
const hasSavedFilter = [FundationsStorageKey, WrsStorageKey, JustWordsStorageKey, EsperanzaSmlStorageKey,
    OtherStorageKey, wilsonHostedStorageKey, partnerHostedStorageKey, inPersonStorageKey,
    virtualStorageKey, graduateCreditStorageKey].some(key => localStorage[key] === 'true');

let revealFallbackTimeout: number;

if (hasSavedFilter) {
    $("#GridContainer").css("visibility", "hidden");
    // Never leave the grid hidden if the filter cannot be applied for any reason.
    revealFallbackTimeout = window.setTimeout(revealGrid, 3000);
}

function revealGrid() {
    window.clearTimeout(revealFallbackTimeout);
    $("#GridContainer").css("visibility", "");
}

function initFilters() {
    loadFilters();
    applyFilterGroups();

    if ($("fieldSet").find("input:checked").length === 0) {
        revealGrid();
        return;
    }

    const grid = $("#GridContainer").dxDataGrid("instance");
    let hasRetried = false;
    const revealWhenFiltered = () => {
        if (!grid.filter() && !hasRetried) {
            hasRetried = true;
            applyFilterGroups();
            return;
        }
        grid.off('contentReady', revealWhenFiltered);
        revealGrid();
    };
    grid.on('contentReady', revealWhenFiltered);
}

$(window).on('load', initFilters);

export function getQueryStringFilter() {
    if (!isFirstLoad) return;
    const urlParams = new URLSearchParams(window.location.search);
    const programFilter = urlParams.get("p");
    const nameFilter = urlParams.get("name");
    if (programFilter || nameFilter) {
        let gridInstance = $("#GridContainer").dxDataGrid("instance");
        showAll();
        if (programFilter) { gridInstance.filter(["ProductRelatedEntityViewModel.ProgramName", "contains", programFilter]); }
        if (nameFilter) { gridInstance.columnOption("Name", "filterValue", nameFilter); }
        switch (programFilter) {
            case 'Fun':
                $("#FundationsCheckbox").prop("checked", true);
                break;
            case 'WRS':
                $("#WRSCheckbox").prop("checked", true);
                break;
            case 'JW':
                $("#JustWordsCheckbox").prop("checked", true);
                break;

            default:
        }
    }
    isFirstLoad = false;
}

export function detailsRedirect(data) {
    window.location.href = `${window.location.pathname}/ProductDetails/${data.Id}`;
}

export function showAll() {
    var gridInstance = $("#GridContainer").dxDataGrid("instance");
    gridInstance.clearFilter();
    $("fieldSet").find("input").prop("checked", false);
}

export function tokenizedFilterExpression(filterValue) {
    const dataField = this.dataField;
    const words = filterValue.split(" ");
    return words.map(word => [dataField, "contains", word]);
}

export function applyFilterGroups() {
    // Store filters in local storage for return trips to this page
    updateLocalStorage();

    const grid = $("#GridContainer").dxDataGrid("instance");

    // Save current filter row values before clearing
    const savedFilterValues = {};
    grid.getVisibleColumns().forEach(col => {
        if (col.dataField !== undefined 
            && col.allowFiltering !== false 
            && col.filterValue !== undefined 
            && col.filterValue !== null 
            && col.filterValue !== '') {
            savedFilterValues[col.dataField] = col.filterValue;
        }
    });

    //Remove all existing filters, we will re-apply them.
    grid.clearFilter();

    //Get all FieldSets, these are the main filter groups.
    const fieldsetNodeList = Array.from(document.getElementsByTagName('fieldset'));
    let groupFilters = [];

    //Build the group based grid filters.
    fieldsetNodeList.forEach(node => groupFilters.push(dynamicFilter(node)));

    //Remove any undefined filters; undefined means no active filters within that group.
    const activeFilterGroups = groupFilters.filter(filterGroup => filterGroup !== undefined);

    //ultimate filter for all groups and their inner filters.
    let gridFilter = [];

    //Bail if we don't have any filters to apply
    if (activeFilterGroups.length === 0) {
        // Restore filter row values even if no checkbox filters
        Object.keys(savedFilterValues).forEach(dataField => {
            grid.columnOption(dataField, "filterValue", savedFilterValues[dataField]);
        });
        return;
    }

    //Join group filters together, if this is the first group filter to apply, ommit the "and" as DevEx does not like having a operator with a single group.
    activeFilterGroups.forEach(groupFilter => gridFilter.length === 0 ? gridFilter.push(groupFilter) : gridFilter.push("and", groupFilter));

    //Apply resulting grouped filters to grid.
    grid.filter(gridFilter);

    // Restore saved filter row values
    Object.keys(savedFilterValues).forEach(dataField => {
        grid.columnOption(dataField, "filterValue", savedFilterValues[dataField]);
    });
}

export function dynamicFilter(node: HTMLFieldSetElement): any {
    //target column to filter.
    const columnTarget = node.dataset.target;

    //Get Checked checkbox inputs within this fieldset group.
    const inputElements = node.getElementsByTagName('input');
    const activeFilters = Array.from(inputElements).filter(el => el.checked);
    let fieldGroupFilters: (string | boolean | string[])[][];

    //IF no filters for this group are active, go to next group.
    if (activeFilters.length == 0) return;

    //Build filter for each input.
    fieldGroupFilters = activeFilters.map(input => {
        if (input.dataset.valueList) {
            const valueListFilter = [];
            input.dataset.valueList.split(",").forEach(value => {
                if (valueListFilter.length > 0) valueListFilter.push("or");
                valueListFilter.push([columnTarget, input.dataset.operator, value]);
            });
            return valueListFilter;
        }
        if (input.dataset.stringMatch) {
            return [columnTarget, input.dataset.operator, input.dataset.value];
        }
        if (input.dataset.stringOther) {
            const claimedValues = Array.from(inputElements)
                .map(sibling => sibling.dataset.valueList ?? sibling.dataset.value)
                .filter(value => value)
                .join(",")
                .split(",");

            const otherFilter = [];
            claimedValues.forEach(value => {
                if (otherFilter.length > 0) otherFilter.push("and");
                otherFilter.push([columnTarget, input.dataset.operator, value]);
            });
            return otherFilter;
        }
        return [columnTarget, input.dataset.operator, input.dataset.value === 'null' ? null : input.dataset.value === 'true'];
    });

    let resultConditions = [];

    //Build Filter criteria for each filter in this group.
    const groupInnerFilters = Array.from(fieldGroupFilters.map(filterCondtion => ["or", filterCondtion]));

    //Build the final list of filters for this group.
    groupInnerFilters.forEach(filterCondition => resultConditions.length === 0 ? resultConditions.push(filterCondition[1]) : resultConditions.push(filterCondition[0], filterCondition[1]));

    //Return Group Filter.
    return resultConditions;
}

function updateLocalStorage() {
    localStorage[wilsonHostedStorageKey] = $("#WilsonHostedCheckbox").prop("checked");
    localStorage[partnerHostedStorageKey] = $("#PartnerHostedCheckbox").prop("checked");
    localStorage[inPersonStorageKey] = $("#InPersonCheckbox").prop("checked");
    localStorage[virtualStorageKey] = $("#VirtualCheckbox").prop("checked");
    localStorage[graduateCreditStorageKey] = $("#GraduateCreditCheckbox").prop("checked");
    localStorage[FundationsStorageKey] = $("#FundationsCheckbox").prop("checked");
    localStorage[WrsStorageKey] = $("#WrsCheckbox").prop("checked");
    localStorage[JustWordsStorageKey] = $("#JustWordsCheckbox").prop("checked");
    localStorage[EsperanzaSmlStorageKey] = $("#EsperanzaSmlCheckbox").prop("checked");
    localStorage[OtherStorageKey] = $("#OtherCheckbox").prop("checked");
}

export function price_cellTemplate(container, options) {
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    const partner = options.data.Partner;
    const price = options.data.RetailPrice;
    const result = (typeof partner !== 'undefined' && partner != null) ? "*See Partner" : formatter.format(price);
    container.append(result);
}

export function partner_cellTemplate(container, options) {
    var imageSrc;
    var partner = options.data.Partner;
    if (partner) {
        if (partner.LogoUrl) {
            imageSrc = partner.LogoUrl;
        }
        else {
            switch (partner.PartnerType) {
                case 0:
                    imageSrc = "partnerlogofull.png";
                    break;
                default:
                    imageSrc = "partnerlogofull-nonaccredited.png";
                    break;
            }
        }
    } else {
        imageSrc = "default-logo.png";
    }
    container
        .append(
            $("<img>").attr({ src: `/src/images/logos/partner/${imageSrc}`, class: "host-img", alt: "Host" })
        );
}

export function name_cellTemplate(container, options) {
    const collaborativeText = options.data.ProductRelatedEntityViewModel?.CollaborativeText;
    const productName = options.data.Name;
    const result = (typeof collaborativeText !== 'undefined' && collaborativeText != null) ? `<div>${productName}</div><div class="data-indented">Co-sponsored by: ${collaborativeText}</div>` : `<div>${productName}</div>`;
    container.append(result);
}

export function location_cellTemplate(container, options) {
    const location = options.data.ProductRelatedEntityViewModel?.Address;
    if (location && location.City && location.RegionCode) {
        const result = `<div>${location.City}, ${location.RegionCode}</div>`;
        container.append(result);
    }
}

export function location_sortValue(rowData) {
    const location = rowData.ProductRelatedEntityViewModel?.Address;
    if (location && location.City && location.RegionCode) {
        return `${location.City}, ${location.RegionCode}`;
    }
}

function loadFilters() {
    $("#WilsonHostedCheckbox").prop("checked", (localStorage[wilsonHostedStorageKey] ?? "false") === "true");
    $("#PartnerHostedCheckbox").prop("checked", (localStorage[partnerHostedStorageKey] ?? "false") === "true");
    $("#InPersonCheckbox").prop("checked", (localStorage[inPersonStorageKey] ?? "false") === "true");
    $("#VirtualCheckbox").prop("checked", (localStorage[virtualStorageKey] ?? "false") === "true");
    $("#GraduateCreditCheckbox").prop("checked", (localStorage[graduateCreditStorageKey] ?? "false") === "true");
    $("#FundationsCheckbox").prop("checked", (localStorage[FundationsStorageKey] ?? "false") === "true");
    $("#WrsCheckbox").prop("checked", (localStorage[WrsStorageKey] ?? "false") === "true");
    $("#JustWordsCheckbox").prop("checked", (localStorage[JustWordsStorageKey] ?? "false") === "true");
    $("#EsperanzaSmlCheckbox").prop("checked", (localStorage[EsperanzaSmlStorageKey] ?? "false") === "true");
    $("#OtherCheckbox").prop("checked", (localStorage[OtherStorageKey] ?? "false") === "true");
}
